import { http } from '../utils/axios';
import { IVisit } from '../interfaces/visit.interface';
import { TConsultationsQueueResponse, TVisitsResponse } from '../types';
import { TFilterOptions } from 'shared/types';

class VisitsService {
  private static instance: VisitsService;

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  private constructor() {}

  static getInstance(): VisitsService {
    if (!VisitsService.instance) {
      VisitsService.instance = new VisitsService();
    }

    return VisitsService.instance;
  }

  getAllVisits = async (payload: TFilterOptions) => {
    const { data } = await http<TVisitsResponse>({
      url: '/visits',
      method: 'GET',
      params: payload
    });

    return data;
  };

  getVisitsInQueue = async (payload: TFilterOptions) => {
    const { data } = await http<TConsultationsQueueResponse>({
      url: '/visits/visitsInQueue',
      method: 'GET',
      params: payload
    });

    return data;
  };

  getVisitsByOrder = async (orderId: string) => {
    const { data } = await http<TVisitsResponse>({
      url: '/visits/visitsByOrder',
      method: 'GET',
      params: { orderId }
    });

    return data;
  };

  getVisitsByPatient = async (payload: TFilterOptions) => {
    const { data } = await http<TVisitsResponse>({
      url: '/visits/visitsByPatient',
      method: 'GET',
      params: payload
    });

    return data;
  };

  getOneVisit = async (id: string) => {
    const { data } = await http<IVisit>({
      url: `/visits/${id}`,
      method: 'GET'
    });

    return data;
  };
}

const instance = VisitsService.getInstance();

export default instance;
